export type MpfVariants = 'neutral' | 'success' | 'error';

export interface MpfNotificationBannerProps {
  heading: string;
  additionalText?: string;
  marginClass?: string;
  isNhsJurisdiction?: boolean;
  organisationPhoneNumber?: string;
  variants?: MpfVariants;
}

export const mpfNotificationBannerDefaults = {
  isNhsJurisdiction: true,
  variants: 'neutral' as MpfVariants,
} satisfies Partial<MpfNotificationBannerProps>;
